/* eslint-disable */
//tslint:disable

export interface IUserBookingStatus {
  /** Тип статуса **/
  type: EType;
  /** Описание состояния отображаемое для пользователя **/
  description?: string | null;
}

export enum EType {
  /** Нет активных записей **/
  NoActive = 'noActive',
  /** Есть активная запись **/
  SignedUp = 'signedUp',
}
